import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {WebOnboardingService} from '../../_services/web-onboarding.service';

@Component({
  selector: 'app-liveness',
  templateUrl: './liveness.component.html',
  styleUrls: ['./liveness.component.css'],
})
export class LivenessComponent implements OnInit, OnDestroy {
  @Output() completed = new EventEmitter<void>();

  loading = true;
  errorMessage = '';

  private destroy$ = new Subject<void>();

  constructor(private onboardingService: WebOnboardingService) {}

  ngOnInit(): void {
    this.startLiveness();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private startLiveness(): void {
    this.loading = true;
    this.errorMessage = '';

    this.onboardingService
      .startFaceLiveness()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          const redirectUrl = response.redirectUrl || response.url || '';

          if (redirectUrl) {
            // Save onboarding state before leaving the page
            sessionStorage.setItem('onboarding_fld', JSON.stringify({
              flowType: 'onboarding',
              biometryId: response.biometryId,
            }));

            // Full redirect to SANII
            window.location.href = redirectUrl;
          } else {
            this.loading = false;
            this.errorMessage = 'No se recibió el enlace de verificación facial. Intentá nuevamente.';
          }
        },
        error: (err) => {
          this.loading = false;
          const body = err.error;
          if (body?.errors?.length) {
            this.errorMessage = body.errors.map((e: any) => e.message).filter(Boolean).join('\n');
          } else if (body?.message) {
            this.errorMessage = body.message;
          } else {
            this.errorMessage = 'Error al iniciar la validación facial. Intentá nuevamente.';
          }
        },
      });
  }

  retry(): void {
    this.startLiveness();
  }
}
